const handleize = (string) => {
  const parts = string.toLowerCase().split(' ').map((part) => part.trim());
  return parts.join('-');
};

export { handleize }; // eslint-disable-line
